// Add your custom JS here
jQuery(document).ready(function($) {
  fetch('/cart.js').then(response => response.json()).then(data => {
    var currencySymbol = data.currency === 'GBP' ? '£' : data.currency === 'USD' ? '$' : data.currency === 'EUR' ? '€' : data.currency;

    /* Hidden Values */
    var stepInput = $('#subscription-step-number'),
    stepPassed = $('#subscription-step-passed'),
    stepMax = stepInput.attr('max'),
    selectedTrialProduct = $('.selected-trial-product'),
    selectedSellingPlan = $('.selected-selling-plan'),
    selectedSellingPlanLabel = $('.selected-selling-plan-label'),
    selectedProductVariant = $('.selected-product-variant'),
    selectedProductVariantInex = $('.selected-product-variant-index'),
    selectedUpsellProduct = $('.selected-upsell-product');

    /* Step Btn Action */
    var stepSection = $('.subscription-step');

    $('.step-footer .cta-btn.prev-step').on('click', function(e) {
      var activeStep = $('.subscription-step.active'),
      stepNum = stepInput.val();

      activeStep.removeClass('active');
      activeStep.prev().addClass('active');
      stepInput.val(parseInt(stepNum) - 1).trigger('change');
      window.scrollTo(0, 0);
    });

    $('.step-footer .cta-btn.next-step').on('click', function(e) {
      var activeStep = $('.subscription-step.active'),
      stepNum = stepInput.val();

      activeStep.removeClass('active');

      if (stepNum == 3 && $('.subscription-step-3b').length > 0) {
        $('.subscription-step-3b').addClass('active');
      } else {
        if ( $('.subscription-step-4').length == 0 && stepNum == 3 ) {
          $('.subscription-step-5').addClass('active');
          $('.subscription-step-footer').each(function(){
            var $this = $(this);
            setTimeout(function(){
              if (!$this.parents('.free-trial-step5').length && !$this.closest('.free-trial-step-5').length) { // Added more robust check for parent
                $this.addClass('hidden');
              }
            },10)
          })
        } else {
          activeStep.next().addClass('active');
        }
      }

      if (stepNum > 4 ) {
        $('.step-footer').hide();
        $('.free-trial-step-5 .step-footer').show();
      } else {
        $('.step-footer').show();
      }



      stepInput.val(parseInt(stepNum) + 1).trigger('change');
      window.scrollTo(0, 0);
    });

    stepSection.each(function() {
      if ( $(this).hasClass('active') ) {
        setTimeout(()=>{
          $(this).find('.free-trial-step-1 .introduction-popup').addClass('active');
        }, 600);
      }
    });

    $('.step-footer .cta-btn.edit-step').on('click', function() {
      stepSection.removeClass('active');
      $('.subscription-step-edit').addClass('active');
      stepInput.val(6).trigger('change');
      window.scrollTo(0, 0);

      // hide extras from edit if there's no step 4

      if ( $('.subscription-step-4').length == 0 ) {
        $('.edit-step-4').remove();
      }
    });

    stepInput.on('change', function() {
      var stepNum = $(this).val();

      if ( stepNum >= stepMax ) {
        $('.step-footer .cta-btn.next-step').attr('disabled', true);
        $('.step-progress-cta').addClass('hidden');
        stepPassed.val('true').trigger('change');
      } else {
        $('.step-footer .cta-btn.next-step').attr('disabled', false);
        $('.step-progress-cta').removeClass('hidden');
      }

      if ( stepNum <= 1 ) {
        $('.step-footer .cta-btn.prev-step').attr('disabled', true);
      } else {
        $('.step-footer .cta-btn.prev-step').attr('disabled', false);
      }

      $('.progressBar-wrapper .stepBar').removeClass('active');

      if ( stepNum > 5 ) stepNum = 5;
      $('.progressBar-wrapper .stepBar[data-id="' + stepNum + '"]').addClass('active');

      stepSection.each(function() {
        if ( $(this).hasClass('active') ) {
          setTimeout(()=>{
            $(this).find('.free-trial-step-1 .introduction-popup').addClass('active');
          }, 1000);
        }
      });
    });

    stepPassed.on('change', function() {
      if ( stepPassed.val() == 'true' ) {
        $('.introduction-popup').addClass('hidden');
        $('.step-footer .non-passed-action').addClass('hidden');
        $('.step-footer .passed-action').removeClass('hidden');
      }
    });

    $('.step-heading .step-popup-atc').on('click', function() {
      $('.free-trial-step-3 .introduction-popup').removeClass('hidden').addClass('active');
    });

    /* Option Select */
    $('.step-container .option-selection .option-card').on('click', function() {
      var $this = $(this);

      $this.parent().find('.option-card').removeClass('active');
      $this.addClass('active');

      if ( $this.hasClass('step1-card') ) {
        var productHandle = $this.data('handle');
        selectedTrialProduct.val(productHandle).trigger('change');
      }

      if ( $this.hasClass('step2-card') ) {
        var productPlanID = $this.data('plan-id');
        var productPlanValue = $this.data('plan-value');
        var productShipmentDay = $this.data('shipment-day');
        var productPlanLabel = $this.find('.option-name').text();

        selectedSellingPlan.val(productPlanID).trigger('change');
        selectedSellingPlanLabel.val(productPlanLabel).trigger('change');
        selectedSellingPlan.attr('data-plan-value', productPlanValue).trigger('data-attribute-changed');
        selectedSellingPlan.attr('data-shipment-day', productShipmentDay).trigger('data-attribute-changed');
      }

      if ( $this.hasClass('step3-card') ) {
        var productPlanID = $this.data('variant-id');
        var productPlanPrice = $this.data('variant-price');

        selectedProductVariant.val(productPlanID).trigger('change');
        selectedProductVariant.attr('data-price', productPlanPrice).trigger('data-attribute-changed');

        $('.step4-card').show();
        if ($('.step-content').hasClass('step-content-eu')) {
          var selectedOption1 = $('.step3-card.active').data('option1');
          $(`.step4-card[data-option1="${selectedOption1}"]`).hide();
          $('.step4-card:visible:first').addClass('active'); // Corrected selector
        }
      }

      if ( $this.hasClass('step4-card') ) {
        var upsellID = $this.data('upsell-id');
        var upsellHandle = $this.data('upsell-handle');
        var upsellPrice = $this.data('upsell-price');

        selectedUpsellProduct.val(upsellID).trigger('change');
        selectedUpsellProduct.attr('data-handle', upsellHandle).trigger('data-attribute-changed');
        selectedUpsellProduct.attr('data-price', upsellPrice).trigger('data-attribute-changed');
      }
    });

    /* Toggle Popup */
    $('.introduction-popup-inner .toggle-popup').on('click', function() {
      $(this).parents('.introduction-popup').toggleClass('active');
    });

    /* Checkout Tabs */
    $('.checkout-tabs .tabs-head .tab').on('click', function() {
      var $this = $(this),
      tabID = $this.data('id');

      $('.checkout-tabs .tabs-head .tab').removeClass('active');
      $('.checkout-tabs .tabs-content .content').removeClass('active');

      $this.addClass('active');
      $('.checkout-tabs .tabs-content .content[data-tab-id="'+ tabID +'"]').addClass('active');
    });

    /* FAQ Accordion */
    $('.faqs-lists-wrapper .faqs-lists .faq-head').on('click', function() {
      var $this = $(this); // Corrected: define $this
      var $target =  $this.next('.faq-desc');

      if ( !$this.hasClass('active') ){
        $this.parents('.faqs-lists').find('.faq-head').removeClass('active');
        $this.parents('.faqs-lists').find('.faq-desc').slideUp();
        $this.addClass('active');
        $target.slideDown();
      } else {
        $this.removeClass('active');
        $target.slideUp();
      }

      return false;
    });

    /* Edit Steps */
    $('.step-footer .save-edit').on('click', function() {
      stepSection.removeClass('active');
      $('.subscription-step-5').addClass('active');
      if ( $('.subscription-step-4').length == 0 ) {
        $('.subscription-step-footer').each(function(){
          var $this = $(this);
          setTimeout(function(){
            if (!$this.parent().hasClass('free-trial-step-5')) {
              $this.addClass('hidden');
            }

          },10)
        })
        stepInput.val(4).trigger('change');
      } else {
        stepInput.val(5).trigger('change');
      }
      window.scrollTo(0, 0);
    });


    $('.edit-steps-wrapper .edit-step .step-edit-btn').on('click', function() {
      var $this = $(this),
      stepID = $this.data('edit-id');

      stepSection.removeClass('active');
      $('.subscription-step-' + stepID).addClass('active');
      stepInput.val(stepID).trigger('change');
      window.scrollTo(0, 0);
    });

    /* Trial Product Selection */
    // Change Selection
    selectedTrialProduct.on('change', function() {
      var handleName = $(this).val();

      $('.step-content .product-variant-selection').removeClass('active');
      $('.step-content .product-variant-selection[data-handle="'+ handleName +'"]').addClass('active');
      // Ensure that we click a visible card if multiple are active before filtering
      $('.step-content .product-variant-selection[data-handle="'+ handleName +'"]').find('.option-card.active:visible').first().click();

      $('.checkout-tabs .variant-item .item-desc').removeClass('active');
      $('.checkout-tabs .variant-item .item-desc[data-handle="'+ handleName +'"]').addClass('active');

      $('.checkout-tabs .future-item .desc .desc-inner').removeClass('active');
      $('.checkout-tabs .future-item .desc .desc-inner[data-handle="'+ handleName +'"]').addClass('active');

      $('.introduction-popup-inner .description-item').removeClass('active');
      if ( handleName == 'trial-podd' ) {
        $('.introduction-popup-inner .description-item[data-handle="podd"]').addClass('active');
      } else {
        $('.introduction-popup-inner .description-item[data-handle="beans-ground"]').addClass('active');
      }
    });

    selectedSellingPlanLabel.on('change', function() {
      var planLabel = $(this).val();
      var variantIndex = selectedProductVariantInex.val();
      $('.free-trial-step-3 .product-variant-selection .step3-card').removeClass('hidden first-elem active');
      $('.free-trial-step-3 .product-variant-selection.active .step3-card').each(function() {
        var variantTitle = $(this).find('.option-name').text();
        var variantDataTitle = $(this).data('title');

        if ( ! variantDataTitle.includes(planLabel) ) {
          $(this).addClass('hidden');
        } else {
          var replaceTitle = variantTitle.replace(' / ' + planLabel, '');
          $(this).find('.option-name').text(replaceTitle);
        }
      });

      $('.free-trial-step-3 .product-variant-selection.active .step3-card:not(.hidden)').each(function(index) {
        var $this = $(this);

        if ( index == 0 ) $this.addClass('first-elem');
        if ( variantIndex == index ) $this.click();
      });
    });

    selectedSellingPlan.on('data-attribute-changed change', function() {
      var productPlanValue = $(this).attr('data-plan-value');
      var productShipmentDay = $(this).attr('data-shipment-day');
      var currentDate = Date.now();
      var shipmentDayTimeStamp = currentDate + (parseInt(productShipmentDay) * 24 * 3600 * 1000);
      var shipmentDayFormat = new Date(shipmentDayTimeStamp);
      var shipmentDayYear = shipmentDayFormat.getFullYear();
      var shipmentDayMonth = (shipmentDayFormat.getMonth() + 1).toString().padStart(2, '0');
      var shipmentDayDate = shipmentDayFormat.getDate().toString().padStart(2, '0');
      var shipmentDayVal = shipmentDayDate + '/' + shipmentDayMonth + '/' + shipmentDayYear;

      $('.checkout-tabs .future-item .desc .plan-value').text('Every '+ productPlanValue +' weeks');
      $('.checkout-tabs .future-item .desc .shipment-value').text(shipmentDayVal);
    });

    // Initial Selection
    $('.option-selection .step1-card.active, .option-selection .step4-card.active').click();

    /* Product Variant Selection */
    var getProductJSON = () => {
      var productHandle = selectedTrialProduct.val();
      var productVariant = selectedProductVariant.val();
      var productPrice = selectedProductVariant.attr('data-price');
      var upsellProductPrice = selectedUpsellProduct.attr('data-price') || "0"; // Default to "0" if empty
      var totalPrice = parseFloat(productPrice || 0) + (upsellProductPrice.length ? parseFloat(upsellProductPrice) : 0);
      var planLabel = selectedSellingPlanLabel.val();
      var sellingPlanLabel = $('.step-content .product-variant-selection.active .step2-card.active .option-name');

      $('.checkout-calculation .total-calculation .value').text(currencySymbol+totalPrice.toFixed(2)); // Ensure toFixed

      if ($('.free-trial-eu').length > 0) {
        var discountedPrice = totalPrice * 0.5;
        $('.checkout-calculation .total-calculation .value').html('<s>' + currencySymbol + totalPrice.toFixed(2) + '</s> ' + currencySymbol + discountedPrice.toFixed(2));
      }

      $('.edit-steps-wrapper .edit-step .trial-product-plan').html(sellingPlanLabel.html());

      if ( productHandle == 'trial-podd' || productHandle == 'free-trial-trial-pods') {
        fetch('/products/nespresso-pods.js').then(response => response.json()).then(product => {
          let futurePrice = (product.variants[0].selling_plan_allocations[0].price)/100;
          $('.edit-steps-wrapper .edit-step .trial-product-variant-label').text('Choose your box');
          $('.checkout-tabs .future-item .desc .price-value').text('@ ' + currencySymbol + futurePrice.toFixed(2));
        }).catch(error => console.error('Error fetching nespresso-pods.js:', error));
      } else {

        if (!$('body').hasClass('free-trial-eu')) {
          fetch('/products/fresh-ground-wholebean-coffee.js').then(response => response.json()).then(product => {
            let futurePrice = (product.variants[1].selling_plan_allocations[0].price)/100;
            $('.edit-steps-wrapper .edit-step .trial-product-variant-label').text('Roasting Profile');
            $('.checkout-tabs .future-item .desc .price-value').text('@ '+ currencySymbol + futurePrice.toFixed(2));
          }).catch(error => console.error('Error fetching fresh-ground-wholebean-coffee.js:', error));
        } else {
          // EU specific handling
          $('.edit-steps-wrapper .edit-step .trial-product-variant-label').text('Roasting Profile');
              $('.checkout-tabs .future-item .desc .price-value').text('@ ' + $('.eu-price').val());
        }
      }

      if (productHandle && productVariant) { // Ensure handle and variant exist
        $.getJSON(window.Shopify.routes.root + 'products/'+ productHandle +'.js', function(product) {
          var variantInfo = product.variants.filter(variant => variant.id == productVariant)[0];
          if (variantInfo) { // Check if variantInfo is found
            var variantImg = variantInfo.featured_image ? variantInfo.featured_image.src : ''; // Handle missing image
            var variantTitle = variantInfo.public_title || product.title; // Fallback for title
            var variantComparePrice = variantInfo.compare_at_price ? variantInfo.compare_at_price / 100 : 0;
            var variantPrice = variantInfo.price ? variantInfo.price / 100 : 0;

            var imgTag = $('<img src="'+ variantImg +'" class="item-img" />');
            if (variantImg) {
              if ( $('.checkout-tabs .variant-item .item-img').length ) {
                $('.checkout-tabs .variant-item .item-img').attr('src', variantImg);
              } else {
                $('.checkout-tabs .variant-item').prepend(imgTag.clone());
              }

              if ( $('.checkout-tabs .future-item .item-img').length ) {
                $('.checkout-tabs .future-item .item-img').attr('src', variantImg);
              } else {
                $('.checkout-tabs .future-item').prepend(imgTag.clone());
              }
            }
            $('.edit-steps-wrapper .edit-step .trial-product-title').text(product.title);
            var replaceTitle = variantTitle.replace(' / ' + planLabel, '');
            $('.variant-item .item-title').text(replaceTitle);
            $('.edit-steps-wrapper .edit-step .trial-product-variant').text(replaceTitle);

            if ( variantComparePrice ) {
              $('.variant-item .item-price .original').text(currencySymbol + variantComparePrice.toFixed(2));
            } else {
               $('.variant-item .item-price .original').text(''); // Clear if no compare price
            }
            if ( variantPrice ) {
              $('.variant-item .item-price .sale').text(currencySymbol + variantPrice.toFixed(2));
            } else {
               $('.variant-item .item-price .sale').text(''); // Clear if no price
            }
          }
        }).fail(function(jqXHR, textStatus, errorThrown) {
            console.error("Error fetching product JSON for " + productHandle + ": " + textStatus, errorThrown);
        });
      }
    }

    var getUpsellProductJSON = () => {
      var upsellProductHandle = selectedUpsellProduct.attr('data-handle');

      if ( !upsellProductHandle || upsellProductHandle == 'none' ) {
        $('.checkout-tabs .upsell-item').addClass('hidden');
        $('.edit-steps-wrapper .edit-step .trial-upsell-title').text('None');
      } else {
        $('.checkout-tabs .upsell-item').removeClass('hidden');

        $.getJSON(window.Shopify.routes.root + 'products/'+ upsellProductHandle +'.js', function(product) {
          var productImg = product.featured_image ? product.featured_image : (product.images && product.images.length > 0 ? product.images[0].src : ''); // Fallback for image
          var productTitle = product.title;
          var productDescription = product.description;
          var productComparePrice = product.compare_at_price ? product.compare_at_price / 100 : 0;
          var productPrice = product.price ? product.price / 100 : 0;

          if (productImg) {
            var imgTag = $('<img src="'+ productImg +'" class="item-img" />');
            if ( $('.checkout-tabs .upsell-item .item-img').length ) {
              $('.checkout-tabs .upsell-item .item-img').attr('src', productImg);
            } else {
              $('.checkout-tabs .upsell-item').prepend(imgTag);
            }
          }
          $('.upsell-item .item-title').text(productTitle);
          $('.upsell-item .item-desc').html(productDescription);
          $('.edit-steps-wrapper .edit-step .trial-upsell-title').text(productTitle);

          if ( productComparePrice ) {
            $('.upsell-item .item-price .original').text(currencySymbol + productComparePrice.toFixed(2));
          } else {
            $('.upsell-item .item-price .original').text('');
          }
          if ( productPrice ) {
            $('.upsell-item .item-price .sale').text(currencySymbol + productPrice.toFixed(2));
          } else {
            $('.upsell-item .item-price .sale').text('');
          }
        }).fail(function(jqXHR, textStatus, errorThrown) {
            console.error("Error fetching upsell product JSON for " + upsellProductHandle + ": " + textStatus, errorThrown);
        });
      }
    }

    getProductJSON();
    getUpsellProductJSON();

    $('.selected-trial-product, .selected-selling-plan, .selected-product-variant, .selected-upsell-product').on('change data-attribute-changed', function() {
      getProductJSON();
    });

    $('.selected-upsell-product').on('data-attribute-changed', function() {
      getUpsellProductJSON();
    });

    selectedProductVariant.on('change', function() {
      var variantID = $(this).val();

      $('.checkout-tabs .variant-item .item-desc .metafield-desc').removeClass('active');
      $('.checkout-tabs .variant-item .item-desc .metafield-desc[data-variant-id="'+ variantID +'"]').addClass('active');

      $('.checkout-tabs .future-item .desc .metafield-desc').removeClass('active');
      $('.checkout-tabs .future-item .desc .metafield-desc[data-variant-id="'+ variantID +'"]').addClass('active');

      var waitForTitle = setInterval(function(){
        if ($('.checkout-tabs .variant-item .item-title').text().length) {
          clearInterval(waitForTitle);

          if (location.pathname == '/pages/free-coffee') {
            var title = $('.checkout-tabs .variant-item .item-title').text(); // Corrected selector
            $('.item-info').find('.item-desc.active').find('.metafield-desc').each(function() {
              if ($(this).find('strong').text().indexOf(title) > -1) {
                $(this).addClass('active');
                $(this).siblings().removeClass('active');
              }
            })

            $('.desc-inner.active').find('.metafield-desc').each(function() {
              if ($(this).text().indexOf(title) > -1) {
                $(this).addClass('active');
                $(this).siblings().removeClass('active');
              }
            });

          }

        }
      },50)

      $('.free-trial-step-3 .product-variant-selection.active .step3-card:not(.hidden)').each(function(index) {
        var $this = $(this);

        if ( $this.hasClass('active') ) selectedProductVariantInex.val(index);
      });
    });

    if ($('.free-trial-step-3b').length > 0) {
      // Load the free tin product data for step 3b
      var getFreeGiftJSON = function() {
        // Get the selected free gift tin product
        var freeGiftProduct = $('.step3b-card.active');
        var upsellHandle = freeGiftProduct.data('upsell-handle');
        var upsellID = freeGiftProduct.data('upsell-id');

        if (upsellHandle && upsellID) { // Ensure both exist
          $.getJSON(window.Shopify.routes.root + 'products/'+ upsellHandle +'.js', function(product) {
            var productImg = $('.step3b-card.active').find('img').attr('src');
            var productTitle = product.title;
            var variantTitle = freeGiftProduct.find('.option-name').text();

            // Display the free gift item in the free-item div
            $('.trial-item.free-item').removeClass('hidden');
            $('.trial-item.free-item .item-title').text(productTitle + ' - ' + variantTitle);
            $('.trial-item.free-item .item-desc').html(product.description);

            // Add the image
            if (productImg) {
              var imgTag = $('<img src="'+ productImg +'" class="item-img" />');
              if ($('.trial-item.free-item .item-img').length) {
                $('.trial-item.free-item .item-img').attr('src', productImg);
              } else {
                $('.trial-item.free-item').prepend(imgTag);
              }
            }

            // Add to cart parameters
            selectedUpsellProduct.attr('data-handle', upsellHandle); // This might be an issue if step 4 also uses selectedUpsellProduct
            selectedUpsellProduct.val(upsellID); // Potentially trigger change if needed, but cart params handle it.
            // For clarity, consider a separate hidden input for free gift if selectedUpsellProduct is strictly for step 4.
            // For now, assuming this is intended to override step 4's upsell if step 3b exists and a gift is chosen.
          }).fail(function(jqXHR, textStatus, errorThrown) {
            console.error("Error fetching free gift JSON for " + upsellHandle + ": " + textStatus, errorThrown);
          });
        }
      };

      // Initial call to load the free gift data
      if($('.step3b-card.active').length) getFreeGiftJSON(); // Call only if an active card exists

      // Handle click on step3b-card
      $('.step-container .option-selection .step3b-card').on('click', function() {
        // The "Option Select" handler already sets this active.
        // We just need to get the data.
        getFreeGiftJSON();
      });
    }


    /* Automatic Progressing */
    $('.step-container .option-selection .option-card').on('click', function(e) { // Added 'e'
      var $this = $(this); // $this is the clicked element
      var stepOfClickedCard = $this.data('step');
      var currentStepDisplayed = stepInput.val(); // Use the already defined stepInput

      // FIX: Prevent recursive loop if a programmatic click targets an option card on the current step.
      if (e.isTrigger && parseFloat(stepOfClickedCard) == parseFloat(currentStepDisplayed)) {
        // console.log('Programmatic click on an option card for the current step. Skipping auto-progression.');
        return;
      }

      if (stepPassed.val() == 'true') return;

      // 'step' here refers to the data-step of the clicked card ($this)
      var step = $this.data('step');
      var nextStep = parseFloat(step) + 1; // Use parseFloat for 'step' in case it's like "3.5"
      var stepProgress = $('.subscription-step');
      // console.log('current step (auto-progress)', step, 'next step (auto-progress)', nextStep);


      if (step == 3) {
        // Go to step 3b instead of step 4 if step3b exists
        if ($('.subscription-step-3b').length > 0) {
          stepProgress.removeClass('active');
          $('.subscription-step-3b').addClass('active');
          stepInput.val(3.5).trigger('change'); // Set step to 3.5 for step3b
          window.scrollTo(0, 0);
          return;
        }

        // console.log('current step (after 3b check)', step, 'next step', nextStep);

        // if there's no step 4 go to step 5
        // Check current step value from input, not just from card data-step, because card click could be on an already active step.
        if ($('.subscription-step-4').length == 0 && stepInput.val() == '3') {
          nextStep = 5;
          $('.subscription-step-footer').each(function(){
            var $footer = $(this); // Use different var name
            setTimeout(function(){
              if (!$footer.parent().hasClass('free-trial-step-5')) {
                $footer.addClass('hidden');
              }
            },10)
          })
        }
      }

      if (step == "3.5" || step == 3.5) {
        nextStep = 4;

        // Handle case where step 4 doesn't exist
        if ($('.subscription-step-4').length == 0) {
          nextStep = 5;
          $('.subscription-step-footer').each(function(){
            var $footer = $(this); // Use different var name
            setTimeout(function(){
              if (!$footer.parent().hasClass('free-trial-step-5')) {
                $footer.addClass('hidden');
              }
            }, 10);
          });
        }

        stepProgress.removeClass('active');
        $('.subscription-step-' + nextStep).addClass('active');
        stepInput.val(nextStep).trigger('change');
        window.scrollTo(0, 0);
        return;
      }

      // Special EU logic
      if ($('.free-trial-eu').length > 0) {
        // The problematic lines that caused the loop if not handled by the e.isTrigger check:
        // if ($('.free-trial-eu').length > 0 && parseFloat(step) > 3) { ... }
        // else { selectedTrialProduct.val('trial-pods-copy').trigger('change'); ... }

        // This logic below was part of the problem, as trigger('change') could re-enter this handler.
        // The e.isTrigger check at the top should now prevent the infinite loop.
        // The original logic for EU can remain if it's otherwise correct.

        if (parseFloat(step) > 3 && !$(this).hasClass('step3b-card')) { // Make sure step3b card does not hide footer
            $('.step-footer').hide();
            $('.free-trial-step-5 .step-footer').show();
            // The following line was a contributor to the loop if 'step' was 3 and no step3b
            // selectedTrialProduct.val('trial-podd').trigger('change');
            var variantItem = $('.variant-item .item-title').text();
            $('.future-item .info-block:first .desc .desc-inner:first').text('100 ' + variantItem + ' Wonky Pods');
        } else if (step < 3 || (step == 3 && $('.subscription-step-3b').length === 0)) { // Apply only if not going to 3b or already past it
            $('.step-footer').show();
            // The following line was a contributor to the loop:
            // selectedTrialProduct.val('trial-pods-copy').trigger('change');
            // $('[data-handle="trial-podd"]').text('100 Wonky Pods'); // This selector seems too broad.
        }


        if (step == 2 || step == 1) {
          $('.prev-step').hide();
        } else {
          $('.prev-step').show();
        }
      }

      // General progression
      stepProgress.removeClass('active');
      $('.subscription-step-'+ nextStep +'').addClass('active');
      // Use parseFloat for step to ensure correct addition for nextStep if step was "3.5"
      // However, nextStep is already calculated above.
      // If step came from card as "3" and nextStep is "4", then stepInput gets "4".
      // If step came from card as "2" and nextStep is "3", then stepInput gets "3".
      // If stepInput needs to be int:
      let finalNextStepValue = Math.floor(nextStep); // e.g. if nextStep became 4.5 from 3.5 + 1, floor it for step numbers.
                                                  // Or, ensure nextStep logic above correctly yields integer step numbers like 4, 5.
                                                  // Given the logic, nextStep should be an integer or 3.5 then 4.
      if (nextStep === 3.5) {
        stepInput.val("3.5").trigger('change');
      } else {
        stepInput.val(parseInt(nextStep)).trigger('change');
      }
      window.scrollTo(0, 0);
    });

    /* Checkout Button */
    $('.step-footer .cta-btn.checkout').on('click', function() {
      var cartParams = [];
      var productSellingPlanID = selectedSellingPlan.val(),
      productVariantID = selectedProductVariant.val(),
      upsellProductID = selectedUpsellProduct.val(); // This is from step 4 usually

      // Product from step 1-3
      if (productVariantID && productSellingPlanID) {
          cartParams.push({
            id: productVariantID,
            quantity: 1,
            selling_plan: productSellingPlanID
          });
      } else {
          console.error("Main product variant or selling plan ID is missing.");
          // Optionally, alert the user or prevent AJAX if essential data is missing.
          // return;
      }

      // Upsell from step 4 (if it exists and was selected)
      // Check if step 4 exists and an upsell was actually selected (not 'none' or 0)
      if ($('.subscription-step-4').length > 0 && upsellProductID && upsellProductID != 0 && selectedUpsellProduct.attr('data-handle') !== 'none') {
        cartParams.push({
          id: upsellProductID,
          quantity: 1
        });
      }

      // Free gift from step 3b (if it exists and was selected)
      if ($('.free-trial-step-3b').length > 0) {
        var freeProductCard = $('.step3b-card.active');
        if (freeProductCard.length > 0) {
            var freeProductID = freeProductCard.data('upsell-id');
            if (freeProductID) {
                // Check if this free product is already the main 'upsellProductID' (if step 4 doesn't exist or wasn't used)
                // Or if it's a distinct item. For now, add it.
                // Ensure it's not doubling up if step 3b *is* the only "upsell" path.
                let isDuplicate = cartParams.some(item => item.id == freeProductID);
                if (!isDuplicate) {
                    cartParams.push({
                        id: freeProductID,
                        quantity: 1
                        // Note: Free gifts usually don't have selling plans.
                    });
                }
            }
        }
      }

      // console.log('🚀 ~ file: custom.js [Final Cart Params] =>', cartParams);

      if (cartParams.length === 0) {
        console.error("Cart is empty, nothing to add.");
        alert("Please make your selections before proceeding to checkout.");
        return;
      }

      $.ajax({ // Clear Cart
        type: 'POST',
        url: '/cart/clear.js',
        dataType: 'json',
        beforeSend: function () {
          $('#loader').removeClass('hidden');
        },
        success: function() {
          $.ajax({ // Add items to Cart
            type: 'POST',
            url: '/cart/add.js',
            data: {
              items: cartParams
            },
            dataType: 'json',
            success: function() {
              window.location.href = '/checkout';
            },
            error: function(jqXHR, textStatus, errorThrown) {
              console.error("Error adding items to cart: ", textStatus, errorThrown, jqXHR.responseJSON);
              $('#loader').addClass('hidden');
              alert("There was an issue adding items to your cart. Shopify's response: " + (jqXHR.responseJSON ? jqXHR.responseJSON.description || jqXHR.responseJSON.message : "Unknown error") + ". Please try again.");
            }
          });
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.error("Error clearing cart: ", textStatus, errorThrown);
            $('#loader').addClass('hidden');
            alert("There was an issue preparing your cart. Please try again.");
        }
      });
    });

    // Check for step 4 and apply the correct class to progress bar

    if ( $('.subscription-step-4').length == 0 ) {
      $('.trial-item.upsell-item').hide().addClass('hidden');
      $('.trial-item.variant-item').css({
        'margin-bottom': '0'
      })

      // remove last step bar
      $('.progressBar-wrapper .stepBar:last-child').remove();
      $('.progressBar-wrapper').addClass('no-step-4 active');
    } else {
      $('.progressBar-wrapper').addClass('active');
    }

  }); // End fetch for currency

setTimeout(function(){
    if ($('body').hasClass('free-trial-eu')) {
    $('.next-step').click();
  }
},500);

  // wait for element .rc-widget to be in DOM - This seems like a placeholder or for another feature

  $('.faq-item').on('click',function() {
    // console.log('clicked faq-item'); // Use this for debugging if needed
    $(this).toggleClass('faq-item-open');
    $(this).find('.faq-answer').slideToggle();
  });

}); // End document.ready